export * from '@primeuix/themes/material/ripple';
export { default } from '@primeuix/themes/material/ripple';
